import { CallTypes, IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { ColumnName } from 'enums/ColumnName';
import { IError } from 'interfaces/review/IReviewDataRow';
import { IReviewInning } from 'interfaces/review/IReviewInning';
import { IReviewPlayer } from 'interfaces/review/IReviewPlayer';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';
import { getErrorMessageForEmptyValues, isPlayerCellEmpty, isSimpleCellEmpty } from './ValidationHelpers';

const simpleValidationColumns: string[] = [ColumnName.PitcherDexterity, ColumnName.BattingSide, ColumnName.Inning, ColumnName.PitchCall];
const playerValidationColumns: string[] = [ColumnName.Pitcher, ColumnName.Batter, ColumnName.Catcher];
const inPlayValidationColumns: string[] = [ColumnName.HitType, ColumnName.PlayResult];
export const emptyCellValidator: IDataGridValidator = {
  validate: (rows: ReviewDataRow[], columns: IDataGridColumnConfiguration[]) => {
    return rows.map((r) => validateRow(r, columns));
  },
};

const validateRow = (row: ReviewDataRow, columns: IDataGridColumnConfiguration[]) => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }
  columns.forEach((col: IDataGridColumnConfiguration) => {
    if (simpleValidationColumns.includes(col.columnName)) {
      if (isSimpleCellEmpty(row[col.dataKey as keyof ReviewDataRow] as string)) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    } else if (playerValidationColumns.includes(col.columnName)) {
      if (isPlayerCellEmpty(row[col.dataKey as keyof ReviewDataRow] as IReviewPlayer)) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    } else if (col.columnName === ColumnName.Inning) {
      const inning = row[col.dataKey as keyof ReviewDataRow] as IReviewInning;
      if (!inning || inning.inningNumber < 1) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    } else if (inPlayValidationColumns.includes(col.columnName)) {
      if (row.pitchCall === CallTypes.InPlay && isSimpleCellEmpty(row[col.dataKey as keyof ReviewDataRow] as string)) {
        errors.push({
          dataKey: col.dataKey,
          errorMessage: getErrorMessageForEmptyValues(col.columnName),
        });
      }
    }
  });
  return errors;
};
